import { render, staticRenderFns } from "./DataList.vue?vue&type=template&id=55ce05e2&scoped=true&"
import script from "./DataList.vue?vue&type=script&lang=js&"
export * from "./DataList.vue?vue&type=script&lang=js&"
import style0 from "./DataList.vue?vue&type=style&index=0&id=55ce05e2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ce05e2",
  null
  
)

export default component.exports